import React, { useContext, useEffect, useState } from "react";
import SeacrhIco from "../../Components/Images/search-ico.svg";
import { Dropdown } from "react-bootstrap";
import ProfileIco from "../../Components/Images/profile-image.png";
import ToggleOpenIco from "../../Components/Images/toggle-off.svg";
import test from "../../Components/Images/toggle-off.svg";
import { parseJwt } from "../../apiService";
import { useNavigate } from "react-router-dom";

export default function Header(props) {

    const navigate = useNavigate();

    const [user_info, set_user_info] = useState({});
    useEffect(() => {
        FetchUserInfo()
    }, [])
    const FetchUserInfo = async () => set_user_info(await parseJwt());

    const addactiveclass = () => document.getElementById("root").classList.toggle("root-add-class");


    const logout = () => {
        localStorage.removeItem('PPKTOKEN');
        navigate("/")
    }

    return (
        <header className="header-div-tops">
            <div className="d-xl-none me-2" onClick={addactiveclass}>
                <img src={ToggleOpenIco} loading="lazy" alt="toggle" />
            </div>
            <div className="d-inline-flex align-items-center header-titles-cust">
                <span>
                    <img src={test} loading="lazy" alt="" />
                </span>
                <h1>Dashboard</h1>
            </div>
            <div className="ms-auto d-flex align-items-center justify-content-end">
                {/* <div className="position-relative src-hdr-tops">
                    <img src={SeacrhIco} loading="lazy" alt="" />
                    <input type="search" className="form-control form-style-input" placeholder="Search..." />
                </div> */}
                <div className="header-profile-cust ms-md-4 ms-3">
                    <Dropdown>
                        <Dropdown.Toggle variant="success">
                            {/* <img src={ProfileIco} className="me-md-2 pe-md-1" loading="lazy" alt="" /> */}
                            <div>{user_info.name ?? ""}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => logout()}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </header>
    );
}
